import ActionTypes from '../constants';

const initialState = {
    loggedIn: null,
    userData: {},
    loginError: null,
    newRecordId: null,
    // loading: false,
};
// userData, 'userData')

const authReducer = (state = initialState, action) => {
    switch (action.type) {
        // case ActionTypes.LOADING:
        //     return {
        //         ...state,
        //         loading: true
        //     }
        case ActionTypes.LOGINREQUESTSUCCESS:
            return {
                ...state,
                userData: action.payload,
                loggedIn: true,
            }
        case ActionTypes.LOGINREQUESTFAILED:
            return {
                ...state,
            }
        case ActionTypes.LOGOUT:
            return {
                ...state,
                userData: {},
                loggedIn: null
            }
        default:
            return state;
    }
}

export default authReducer;